// extracted by mini-css-extract-plugin
module.exports = {"progressHeader":"styles__progressHeader___2YNYB","footer":"styles__footer___1UkqG"};